// import { checkingPreload, unCheckingPreload } from '../auth/authSlice';
import { 
    createShiftDemandService, 
    createPlanningShiftRequestService,
    getPlanningShiftRequestByIdService,
    updatePlanningShiftRequestService,
    getShiftDemandsService, 
    updateShiftDemandService, 
    deleteShiftDemandService, 
    restoreShiftDemandService, 
    getDataRequerimientoPersonalCreateService
} from '../../services/shiftDemands.service';
import { setShiftDemandsListRedux, setMetaShiftDemandsRedux } from './shiftDemandsSlice';
import { mapperShiftDemandsFromBackend } from '../../pages/programador-inteligente/requerimiento-personal/mappers/shiftDemands.mapper';
import { checkingPreload, unCheckingPreload } from '../loading';
import { setCargosSelectRedux } from '../cargos/cargoSlice';
import { setTemplatesForSelect } from '../shift_templates/shiftTemplatesSlice';

export const getShiftDemandsStore = (page: number, take: number, param?: string) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await getShiftDemandsService(page, take, param);
        
        if (result && result.ok) {
            const mappedData = result.data.data.map((item: any) => mapperShiftDemandsFromBackend(item));
            await dispatch(setShiftDemandsListRedux(mappedData));
            await dispatch(setMetaShiftDemandsRedux(result.data.meta));
            
            if (result.data.plantillas) {
                dispatch(setTemplatesForSelect(result.data.plantillas));
            }
            if (result.data.cargos) {
                dispatch(setCargosSelectRedux(result.data.cargos));
            }
        }
        dispatch(unCheckingPreload());
        return result;
    };
};




export const getDataRequerimientoPersonalCreateStore = () => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await getDataRequerimientoPersonalCreateService();
        
        if (result && result.ok) {
            await dispatch( setCargosSelectRedux(result.data.positions) );
            await dispatch( setTemplatesForSelect(result.data.templates) );
        }
        dispatch(unCheckingPreload()); 
        return result;
    };
};



export const savePlanningShiftRequestStore = (payload: any) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await createPlanningShiftRequestService(payload);
        dispatch(unCheckingPreload());
        return result;
    };
};

export const getPlanningShiftRequestByIdStore = (id: string) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await getPlanningShiftRequestByIdService(id);
        dispatch(unCheckingPreload());
        return result;
    };
};

export const updatePlanningShiftRequestStore = (id: string, payload: any) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await updatePlanningShiftRequestService(id, payload);
        dispatch(unCheckingPreload());
        return result;
    };
};

export const saveShiftDemandStore = (payload: any, page: number, take: number, param?: string, status: number = 1) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await createShiftDemandService(payload);
        
        if (result && result.ok) {
            await dispatch(getShiftDemandsStore(page, take, param));
        }
        dispatch(unCheckingPreload());
        return result;
    };
};

export const updateShiftDemandStore = (id: string, payload: any, page: number, take: number, param?: string, status: number = 1) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await updateShiftDemandService(id, payload);
        
        if (result && result.ok) {
            await dispatch(getShiftDemandsStore(page, take, param));
        }
        dispatch(unCheckingPreload());
        return result;
    };
};

export const deleteShiftDemandStore = (id: string, page: number, take: number, param?: string) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await deleteShiftDemandService(id);
        
        if (result && result.ok) {
            await dispatch(getShiftDemandsStore(page, take, param));
        }
        dispatch(unCheckingPreload());
        return result;
    };
};

export const restoreShiftDemandStore = (id: string, page: number, take: number, param?: string) => {
    return async (dispatch: any) => {
        dispatch(checkingPreload());
        const result = await restoreShiftDemandService(id);
        
        if (result && result.ok) {
            await dispatch(getShiftDemandsStore(page, take, param));
        }
        dispatch(unCheckingPreload());
        return result;
    };
};
